import Field from "src/components/field/Field";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";

interface TaskDetailFieldsProps extends Translation {
	className?: string;
}

const TaskDetailFields = ({ t, className }: TaskDetailFieldsProps) => {
	const { task, actions } = useTaskForm();

	return (
		<div className={`flex flex-col gap-2 ${className}`}>
			{task.type === "INTERNAL" && (
				<>
					<Field.Status
						wrapper={{ label: "Status", layout: "horizontal" }}
						value={task.status}
						onChange={(value) => {
							actions.set({
								status: value,
							});
						}}
					/>
					<Field.Date
						wrapper={{ label: "Deadline", layout: "horizontal" }}
						value={task.end_date}
						onChange={(value) => {
							actions.set({
								end_date: value,
							});
						}}
					/>
					<Field.Tag
						canCreate
						wrapper={{ label: "Tags", layout: "horizontal" }}
						value={(task?.tags || []).map(
							(tag: any) => tag?.tag || tag
						)}
						onChange={(tags) => {
							actions.set({
								tags,
							});
						}}
					/>
					<Field.Users
						wrapper={{
							label: t("fields.assignees.label"),
							layout: "horizontal",
						}}
						value={
							task.assignees
								? task.assignees.map((user: any) =>
										typeof user === "object"
											? user.id.toString()
											: user
								  )
								: []
						}
						onChange={(value) => {
							actions.set({
								assignees: value,
							});
						}}
					/>
				</>
			)}
		</div>
	);
};

TaskDetailFields.locale = {
	nl: {
		title: "",
		fields: {
			assignees: {
				label: "Uitvoerders",
			},
		},
	},
	en: {
		title: "",
		fields: {
			assignees: {
				label: "Assignees",
			},
		},
	},
};

export default withTranslation(TaskDetailFields);
